<template>
    <div class="login-page">
        <a href="/screens" class="login-page-nav">Карта экранов</a>
        <div class="login-wrapper register-wrapper">
            <div class="login-container">
            <div class="login-card register-card">
                <div class="login-header">
                    <img src="/images/2digital-horis.png" alt="2Digital" class="login-logo" />
                    <h1 class="login-title">Регистрация МСБ</h1>
                    <p class="login-subtitle">Заявка на доступ к платформе</p>
                </div>

                <form @submit.prevent="handleSubmit" class="login-form register-form" novalidate>
                    <div class="form-group">
                        <span class="form-label">Тип организации</span>
                        <div class="type-switch" role="radiogroup" aria-label="Тип организации">
                            <label class="type-option" :class="{ active: form.type === 'ip' }">
                                <input v-model="form.type" type="radio" name="type" value="ip" />
                                ИП
                            </label>
                            <label class="type-option" :class="{ active: form.type === 'too' }">
                                <input v-model="form.type" type="radio" name="type" value="too" />
                                ТОО
                            </label>
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="form-label" for="registrant_full_name">ФИО кто проводит регистрацию</label>
                        <input id="registrant_full_name" v-model="form.registrant_full_name" type="text"
                            class="form-input" required autocomplete="name" />
                    </div>

                    <template v-if="form.type === 'ip'">
                        <div class="form-group">
                            <label class="form-label" for="ip_official_name">Официальное название ИП</label>
                            <input id="ip_official_name" v-model="form.ip_official_name" type="text"
                                class="form-input" required />
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="iin">ИИН</label>
                            <input id="iin" v-model="form.iin" type="text" class="form-input" inputmode="numeric"
                                maxlength="12" pattern="[0-9]{12}" required placeholder="12 цифр" />
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="residence_address">Адрес места жительства</label>
                            <input id="residence_address" v-model="form.residence_address" type="text"
                                class="form-input" required />
                        </div>
                        <div class="form-group form-group--checkbox">
                            <label class="checkbox-label">
                                <input v-model="form.activity_address_differs" type="checkbox" />
                                Адрес места ведения деятельности отличается
                            </label>
                        </div>
                        <div v-if="form.activity_address_differs" class="form-group">
                            <label class="form-label" for="activity_address">Адрес места ведения деятельности</label>
                            <input id="activity_address" v-model="form.activity_address" type="text"
                                class="form-input" required />
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="ip_trade_name">Название ИП (если не совпадает с фамилией)</label>
                            <input id="ip_trade_name" v-model="form.ip_trade_name" type="text" class="form-input"
                                placeholder="Опционально" />
                        </div>
                    </template>

                    <template v-else>
                        <div class="form-group">
                            <label class="form-label" for="company_name">Название компании</label>
                            <input id="company_name" v-model="form.company_name" type="text" class="form-input"
                                required />
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="bin">БИН</label>
                            <input id="bin" v-model="form.bin" type="text" class="form-input" inputmode="numeric"
                                maxlength="12" pattern="[0-9]{12}" required placeholder="12 цифр" />
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="location_address">Адрес места нахождения</label>
                            <input id="location_address" v-model="form.location_address" type="text"
                                class="form-input" required />
                        </div>
                        <div class="form-group form-group--checkbox">
                            <label class="checkbox-label">
                                <input v-model="form.legal_address_differs" type="checkbox" />
                                Юридический адрес отличается от фактического
                            </label>
                        </div>
                        <div v-if="form.legal_address_differs" class="form-group">
                            <label class="form-label" for="legal_address">Юридический адрес</label>
                            <input id="legal_address" v-model="form.legal_address" type="text" class="form-input"
                                required />
                        </div>
                        <div class="form-group">
                            <label class="form-label" for="position">Должность</label>
                            <input id="position" v-model="form.position" type="text" class="form-input" required />
                        </div>
                    </template>

                    <div class="form-group">
                        <label class="form-label" for="oked_primary">Код ОКЭД (основной вид деятельности)</label>
                        <input id="oked_primary" v-model="form.oked_primary" type="text" class="form-input" required />
                    </div>

                    <div v-if="form.type === 'too'" class="form-group">
                        <label class="form-label" for="oked_additional">Дополнительные коды ОКЭД</label>
                        <input id="oked_additional" v-model="okedAdditionalText" type="text" class="form-input"
                            placeholder="Через запятую, опционально" />
                    </div>

                    <div class="form-group">
                        <label class="form-label" for="phone">Телефон</label>
                        <input id="phone" v-model="form.phone" type="tel" class="form-input" required
                            autocomplete="tel" />
                    </div>

                    <div class="form-group">
                        <label class="form-label" for="email">Email</label>
                        <input id="email" v-model="form.email" type="email" class="form-input" required
                            autocomplete="email" />
                    </div>

                    <div class="form-group">
                        <label class="form-label" for="password">Пароль</label>
                        <input id="password" v-model="form.password" type="password" class="form-input" required
                            autocomplete="new-password" minlength="8" />
                    </div>

                    <div class="form-group">
                        <label class="form-label" for="password_confirmation">Подтверждение пароля</label>
                        <input id="password_confirmation" v-model="form.password_confirmation" type="password"
                            class="form-input" required autocomplete="new-password" minlength="8" />
                    </div>

                    <div class="form-group form-group--checkbox">
                        <label class="checkbox-label">
                            <input v-model="form.offer_accepted" type="checkbox" required />
                            <span>
                                Принимаю условия
                                <a :href="offerUrl" target="_blank" rel="noopener noreferrer">оферты</a>
                            </span>
                        </label>
                    </div>

                    <div v-if="errorMessage" class="error-message">
                        {{ errorMessage }}
                    </div>

                    <button type="submit" class="login-button" :disabled="isLoading || !canSubmit"
                        :class="{ loading: isLoading }">
                        <span v-if="!isLoading">Отправить заявку</span>
                        <span v-else class="button-loader"></span>
                    </button>

                    <p class="login-footer-link">
                        Уже есть аккаунт?
                        <a href="/login">Войти</a>
                    </p>
                </form>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Register',
    props: {
        offerUrl: {
            type: String,
            default: '#',
        },
    },
    data() {
        return {
            form: {
                type: 'ip',
                registrant_full_name: '',
                ip_official_name: '',
                iin: '',
                residence_address: '',
                activity_address_differs: false,
                activity_address: '',
                ip_trade_name: '',
                company_name: '',
                bin: '',
                location_address: '',
                legal_address_differs: false,
                legal_address: '',
                position: '',
                oked_primary: '',
                phone: '',
                email: '',
                password: '',
                password_confirmation: '',
                offer_accepted: false,
            },
            okedAdditionalText: '',
            errorMessage: '',
            isLoading: false,
            csrf: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        };
    },
    computed: {
        canSubmit() {
            const f = this.form;
            if (!f.registrant_full_name || !f.phone || !f.email || !f.password || !f.password_confirmation) {
                return false;
            }
            if (!f.oked_primary || !f.offer_accepted) {
                return false;
            }
            if (f.type === 'ip') {
                if (!f.ip_official_name || !f.iin || !f.residence_address) {
                    return false;
                }
                if (f.activity_address_differs && !f.activity_address) {
                    return false;
                }
                return true;
            }
            if (!f.company_name || !f.bin || !f.location_address || !f.position) {
                return false;
            }
            if (f.legal_address_differs && !f.legal_address) {
                return false;
            }
            return true;
        },
    },
    methods: {
        buildPayload() {
            const f = this.form;
            const payload = {
                type: f.type,
                registrant_full_name: f.registrant_full_name.trim(),
                phone: f.phone.trim(),
                email: f.email.trim(),
                password: f.password,
                password_confirmation: f.password_confirmation,
                oked_primary: f.oked_primary.trim(),
                offer_accepted: f.offer_accepted,
            };

            if (f.type === 'ip') {
                payload.ip_official_name = f.ip_official_name.trim();
                payload.iin = f.iin.trim();
                payload.residence_address = f.residence_address.trim();
                payload.activity_address_differs = f.activity_address_differs;
                payload.activity_address = f.activity_address_differs ? f.activity_address.trim() : null;
                payload.ip_trade_name = f.ip_trade_name.trim() || null;
            } else {
                payload.company_name = f.company_name.trim();
                payload.bin = f.bin.trim();
                payload.location_address = f.location_address.trim();
                payload.legal_address_differs = f.legal_address_differs;
                payload.legal_address = f.legal_address_differs ? f.legal_address.trim() : null;
                payload.position = f.position.trim();
                payload.oked_additional = this.okedAdditionalText
                    .split(',')
                    .map((s) => s.trim())
                    .filter(Boolean);
            }

            return payload;
        },
        async handleSubmit() {
            this.errorMessage = '';
            this.isLoading = true;

            try {
                const response = await fetch('/register', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-CSRF-TOKEN': this.csrf,
                    },
                    body: JSON.stringify(this.buildPayload()),
                });

                const data = await response.json().catch(() => ({}));

                if (response.ok) {
                    window.location.href = data.redirect_url || '/login?registered=1';
                    return;
                }

                if (data.errors) {
                    const errors = Object.values(data.errors).flat();
                    this.errorMessage = errors[0] || 'Ошибка регистрации';
                } else {
                    this.errorMessage = data.message || 'Ошибка регистрации';
                }
            } catch (e) {
                this.errorMessage = 'Произошла ошибка. Попробуйте ещё раз.';
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>
